import { ORDERED_GRADES } from '@/lib/grades';
import { z } from 'zod';

export const classroomGrade = ORDERED_GRADES;
export const classroomGradeError = `Classroom grade must be one of ${classroomGrade.join(', ')}`;

export const buildClassroomErrorMessages = ({
  nameMin,
  nameMax,
  descriptionMin,
  descriptionMax,
  nicknameMin,
  nicknameMax,
}: {
  nameMin: number;
  nameMax: number;
  descriptionMin: number;
  descriptionMax: number;
  nicknameMin: number;
  nicknameMax: number;
}) => ({
  nameMinError: `Classroom name must be at least ${nameMin} characters long`,
  nameMaxError: `Classroom name must be at most ${nameMax} characters long`,
  descriptionMinError: `Classroom description must be at least ${descriptionMin} characters long`,
  descriptionMaxError: `Classroom description must be at most ${descriptionMax} characters long`,
  gradeError: classroomGradeError,
  startDateError: `start date must be a valid date`,
  endDateError: `end date must be a valid date`,
  nicknameMinError: `Nickname must be at least ${nicknameMin} characters long`,
  nicknameMaxError: `Nickname must be at most ${nicknameMax} characters long`,
});

export const selectableGradeSchema = z.enum(ORDERED_GRADES);

export const optionalGradesSchema = z
  .array(selectableGradeSchema)
  .max(ORDERED_GRADES.length)
  .optional();

export const requiredGradesSchema = z
  .array(selectableGradeSchema)
  .min(1, { message: classroomGradeError })
  .max(ORDERED_GRADES.length)
  .optional();

export const repeatedGradesQuerySchema = z.preprocess((value) => {
  if (value == null) {
    return undefined;
  }

  return Array.isArray(value) ? value : [value];
}, z.array(selectableGradeSchema).optional());

export const requireClassroomGrade = <T extends z.ZodTypeAny>(schema: T) =>
  schema.refine(
    (data) =>
      Boolean(
        (data as { grades?: string[]; grade?: string }).grades?.length ||
        (data as { grade?: string }).grade
      ),
    {
      message: classroomGradeError,
      path: ['grades'],
    }
  );
